import React from 'react';
import { useForm } from 'react-hook-form';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../../components';
import { FORM_ADD_BRAND } from '../form';
import { ContainerButton } from '../../../../styles/global-style';
import { useInsertBrand } from '../hooks/useInsertBrand';
import { handleSubmitForm } from '../func/handleSubmitForm';

export const AddBrand = ({ open, onToggle, onFetch }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({ defaultValues: '' });

  const { mutate: onSubmitInsertBrand } = useInsertBrand({
    onSuccessCallBack: onFetch,
  });

  const onSubmit = (values) => {
    handleSubmitForm(values, onSubmitInsertBrand);
    onToggle({ defaultValues: '' });
  };

  return (
    <ModalTheme title="เพิ่มแบรนด์มือถือ" open={open} onToggle={onToggle}>
      <RenderForm
        control={control}
        setValue={setValue}
        getValues={getValues}
        forms={FORM_ADD_BRAND()}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
